import React from "react";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "../Global/NanoFlex.js";
import Type from "../Global/Typography.js";

const multiple = nota.global.multiple;

const StyledArticle = styled.div`
  .articleWrapper {
    p {
      margin: ${multiple / 2 + "px"} 0; /* 4px */
    }
  }
`;

const Article = (props) => {
  return (
    <StyledArticle>
      <NanoFlex className="articleWrapper" justifyContent={"flex-start"} alignContent={"flex-start"}>
        <Type.p justify>{props.article}</Type.p>
      </NanoFlex>
    </StyledArticle>
  );
};

// Set default props
Article.defaultProps = {
  article: "", // 'Article'
};

export default Article;

// --- // Documentation // --- //
/*
import Article from './../Nano/Article.js';

<Article
    article={'Article'}
/>
*/
